/* eslint-disable react/prop-types */
import styled from '@emotion/styled';
import _ from 'lodash';

import ImageAttribution from './oc-image-attribution';
import Picture from './oc-picture';
import Heading from './PageBuilder/Heading';
import RichText from './PageBuilder/RichText';
// eslint-disable-next-line camelcase
import placeholder_url from '../../placeholder';

const heights = {
  tall: 680,
  medium: 464,
  short: 240,
};

const ImageContainer = styled.div`
  display: inline-block;
  margin-bottom: 32px;
  position: relative;
  width: 100%;

  picture {
    display: inline-block;
  }
`;

const HeroImage = styled(Picture)`
  display: inline-block;
  max-height: ${heights.short}px;
  object-fit: cover;
  object-position: center;
  width: 100%;

  @media (min-width: 768px) {
    max-height: ${props => heights[props.$height]}px;
  }
`;

const HeroTextContainer = styled.div`
  padding: 0 15px;

  @media (min-width: 1200px) {
    padding: 0 85px;
  }
`;

const HeroType6 = ({ copy, image, height = 'short' }) => {
  const imageUrl = image && Picture.DefaultOrCrop(image.file, image.crop, placeholder_url(1360, heights[height]));

  return (
    <>
      <ImageContainer>
        <HeroImage source={imageUrl} $height={height} alt={image?.alt} />
        {image?.attribution && <ImageAttribution copy={image.attribution} />}
      </ImageContainer>
      <HeroTextContainer>
        <Heading mainHeading={copy?.mainHeading} />
        <RichText content={copy?.body} />
      </HeroTextContainer>
    </>
  );
};

export default HeroType6;
